export default class AppSettings {
    static getTokenVersion = () => '1.0.0';
    static getAppEnv = () => process.env.REACT_APP_APPENV;
    static getAppVersion = () => process.env.REACT_APP_APPVERSION;
    static getBackendUrl = () => process.env.REACT_APP_BACKEND_ENDPOINT;
    static getGeoserverUrl = () => process.env.REACT_APP_GEOSERVER;
    static getPyheightUrl = () => process.env.REACT_APP_PYHEIGHT;
    static getGoogleApiKey = () => process.env.REACT_APP_GOOGLE_API_KEY;
    static getGoogleClientId = () => process.env.REACT_APP_GOOGLE_CLIENT_ID;
    static getMicrosoftClientId = () => process.env.REACT_APP_MICROSOFT_CLIENT_ID;
    static getStripeKey = () => process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    static getGoogleReCAPTCHAKey = () => process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
    static isUrbasenseUrl = () => window.location.hostname.toLowerCase().includes('urbasense');
    static areBenchmarksEnabled = () => process.env.REACT_APP_ENABLE_BENCHMARKS === 'true';
    static isBenchmarksXlsxExportEnabled = () => process.env.REACT_APP_ENABLE_BENCHMARKS_XLXS_EXPORT === 'true';

    static isElementsPreloadEnabled = () => process.env.REACT_APP_PRELOAD_ELEMENTS !== 'false';

    // Forçable via localStorage 'grality-trees-binary' : voir docs/binary-trees/COOKBOOK.md §4.3
    static isTreesBinaryEnabled = () => {
        try {
            const forced = localStorage.getItem('grality-trees-binary');
            if (forced === 'off') return false;
            if (forced === 'on') return true;
        } catch { /* stockage indisponible */ }
        return process.env.REACT_APP_TREES_BINARY !== 'false';
    };

    static getBlobInfos = () => ({
        endpoint: process.env.REACT_APP_BLOB_ENDPOINT,
        containers: {
            photos: process.env.REACT_APP_BLOB_PHOTOS, zips: process.env.REACT_APP_BLOB_ZIPS, files: process.env.REACT_APP_BLOB_FILES,
            backgroundImages: process.env.REACT_APP_BLOB_BACKGROUNDIMAGES, temporary: process.env.REACT_APP_BLOB_TEMPORARY
        }
    });

    static getBlobUrl = (bucket, fileKey) => process.env.REACT_APP_BLOB_ENDPOINT.replace('https://', `https://${bucket}.`).replace('http://', `http://${bucket}.`) + fileKey;
}